// Join, donate, and upgrade routing and success handling
import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import member from "./session";
import { levels, memberLevel } from "./components/common/Levels";
import "../css/members.css";
import Button from "./components/common/Button";
import ChangeLevel from "./components/members/ChangeLevel";
import ContributeNav from "./components/common/ContributeNav";
import FormWithBilling from "./components/common/FormWithBilling";
import GhostContentPage from "./components/common/GhostContentPage";
import Artifact from "./components/common/Artifact";

const Contribute = () => {
  const [formSuccess, setFormSuccess] = useState(false);
  const handleFormSuccess = (bool) => {
    setFormSuccess(bool);
  };
  const [newMember, setNewMember] = useState();
  const handleNewMember = (num) => {
    setNewMember(num);
  };
  const [mode, setMode] = useState(document.location.pathname.slice(1, -1));
  const handleMode = (path) => {
    setMode(path);
  };

  const fields = {
    join: {
      membership_level: "",
      cc_recurring: "MONT",
      email: "",
      billing_line1: "",
      billing_line2: "",
      billing_city: "",
      billing_state: "",
      billing_zip: "",
      billing_state: "",
      billing_country: "US",
      shipping_line1: "",
      shipping_line2: "",
      shipping_city: "",
      shipping_state: "",
      shipping_zip: "",
      shipping_state: "",
      shipping_country: "US",
      full_name: "",
      username: "",
      password: "",
      reason: "",
    },
    donate: {
      donation_amount: "",
      email: "",
      billing_line1: "",
      billing_line2: "",
      billing_city: "",
      billing_state: "",
      billing_zip: "",
      billing_state: "",
      billing_country: "US",
    },
  };

  if (formSuccess) {
    return (
      <div className="component-contribute">
        {mode == "join" && (
          <div className="page-intro">
            <h2>Welcome to Long Now Membership</h2>
            <p>
              A stainless steel membership card etched with #
              {parseInt(newMember).toLocaleString("en-US")} your unique member
              number, will be on its way to you shortly.
            </p>
            <GhostContentPage slug={"new-member-message"} />
            <Button action="memberCenter" />
          </div>
        )}
        {mode == "donate" && (
          <div className="page-intro">
            <GhostContentPage slug={"new-donation-message"} />
            {member && <Button action="memberCenter" />}
          </div>
        )}
      </div>
    );
  } else {
    if (mode == "upgrade") {
      return (
        <div className="render-upgrade-level">
          <ChangeLevel
            mode={mode}
            handleMode={handleMode}
            levels={levels}
            member={member}
            memberLevel={memberLevel}
          />
        </div>
      );
    } else if (mode == "artifacts") {
      return (
        <div className="component-contribute">
          <ContributeNav mode={mode} handleMode={handleMode} />
          <div className="page-surface">
            <GhostContentPage slug={"artifacts"} />
            <Artifact slug={"rosetta-archive-pendant"} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="component-contribute">
          <ContributeNav mode={mode} handleMode={handleMode} />
          <div className="page-surface">
            <FormWithBilling
              action={mode}
              fields={fields.mode}
              formSuccess={formSuccess}
              handleFormSuccess={handleFormSuccess}
              member={member}
              newMember={newMember}
              handleNewMember={handleNewMember}
            />
          </div>
        </div>
      );
    }
  }
};
export default Contribute;
const root = ReactDOM.createRoot(document.getElementById("contribute-action"));
root.render(<Contribute />);
